<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
    <g transform="translate(-15 -477)">
      <circle
        cx="17"
        cy="17"
        r="17"
        transform="translate(15 477)"
        :fill="color"
      />
      <g transform="translate(-71.279 129.721)">
        <g transform="translate(96.279 357.279)" fill="none" stroke="#383935">
          <circle cx="3" cy="3" r="3" stroke="none" />
          <circle cx="3" cy="3" r="2.5" fill="none" />
        </g>
        <g transform="translate(104.279 357.279)" fill="none" stroke="#383935">
          <circle cx="3" cy="3" r="3" stroke="none" />
          <circle cx="3" cy="3" r="2.5" fill="none" />
        </g>
        <circle cx="3" cy="3" r="3" transform="translate(96.279 365.279)" fill="#383935" />
        <g transform="translate(104.279 365.279)" fill="none" stroke="#383935">
          <circle cx="3" cy="3" r="3" stroke="none" />
          <circle cx="3" cy="3" r="2.5" fill="none" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SectionsIcon',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)',
    },
  },
}
</script>

<style scoped>
svg {
  width: 34px;
  height: 34px;
}
</style>
